// import React from 'react';
// import { Card, Button, Alert } from 'react-bootstrap';
// import { NavLink, Link } from 'react-router-dom';


// import Breadcrumb from '../../../layouts/AdminLayout/Breadcrumb';
// // import clubLogo from "../../../assets/images/clubworldicon.png";
// import clubLogo1 from '../../../assets/images/club-transparentlogo.png';
// import tncaLogo from '../../../assets/images/TNCA/logo.png';

// // import wellington from '../../../../src/assets/images/wellington2.png';
// import FirebaseLogin from './FirebaseLogin';
// import { clientclublogo } from '../../../components/image';


// const Signin1 = () => {
//   return (
//     <React.Fragment>
//       <Breadcrumb />
//       <div class="login-web">
//         <div className="auth-wrapper">
//           <div className="auth-content text-center">
//             <Card className="borderless">
//               <Card.Body className="card-body-logo">
//                 <div className="login-header">
//                   <div className="logo-flex">
//                     <div className="logo-item">
//                       <img src={clubLogo1} alt="" className="img-fluid img-fluid2 " />
//                     </div>
//                     <div className="logo-item2">
//                       <img src={clientclublogo} alt="" className="img-fluid img-fluid2 " />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="login-body">
//                   <FirebaseLogin />
//                   <p className="mb-2 text-muted" stytle={{textAlign:"center"}}>
//                     Forgot password?{' '}
//                     <NavLink to="/auth/reset-password-1" className="f-w-400">
//                       Reset
//                     </NavLink>
//                   </p>
// {/* 
//                   <p className="mb-2 text-muted">
//                     If you are Affiliated club member? <br></br>
//                     <NavLink to="/auth/affiliated" className="f-w-400">
//                       Book Now
//                     </NavLink>
//                   </p> */}
//                 </div>
//               </Card.Body>
//             </Card>
//           </div>
//         </div>
//       </div>

//       <div class="login-mobile">
//         {/* <div className="auth-wrapper"> */}

//         {/* <div className="auth-content text-center"> */}
//         <Card className="borderless">
//           <Card.Body className="card-body-logo">
//             <div className="login-header">
//               <div className="logo-flex-1">
//                 {/* <div className='logo-item'>
//                   <img src={clubLogo2} alt="" className="img-fluid img-fluid2 " />
//                 </div> */}
//                 <div className="logo-item2">
//                   <img src={clientclublogo} alt="" className="img-fluid img-fluid2 " />
//                 </div>
//               </div>
//             </div>
//             <div className="login-body">
//               <h6 style={{ textAlign: 'center', paddingBottom: '10px' }}>LOGIN</h6>
//               <FirebaseLogin />
//               <p className="mb-2 text-muted" style={{ textAlign:"center" }}>
//                 Forgot password?{' '}
//                 <NavLink to="/auth/reset-password-1" className="f-w-400">
//                   &nbsp; Reset
//                 </NavLink>
//               </p>
//               {/* <p className="mb-2 text-muted" style={{ textAlign: 'center' }}>
//                 If you are Affliated club member? <br></br>
//                 <NavLink to="/auth/affiliated" className="f-w-400">
//                   Book Now
//                 </NavLink>
//               </p> */}
//             </div>

//             <div class="footer-page">
//               <p className="mb-2 text-muted">
//                 Powered By <strong style={{ color: '#fd6051' }}>ClubWorld</strong>{' '}
//               </p>
//             </div>
//           </Card.Body>
//         </Card>
//       </div>
//       {/* </div> */}
//       {/* </div></div> */}
//     </React.Fragment>
//   );
// };

// export default Signin1;


import React from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { NavLink, Link, useNavigate } from 'react-router-dom';

import Breadcrumb from '../../../layouts/AdminLayout/Breadcrumb';
// import clubLogo from "../../../assets/images/clubworldicon.png";
import clubLogo1 from '../../../assets/images/club-transparentlogo.png';
import tncaLogo from '../../../assets/images/TNCA/logo.png';

// import wellington from '../../../../src/assets/images/wellington2.png';
import FirebaseLogin from './FirebaseLogin';
import { clientclublogo } from '../../../components/image';

const Signin1 = () => {
  const navigate = useNavigate();
  const handleNavigate = (navig) => {
    navigate(navig);
  };
  return (
    <React.Fragment>
      <Breadcrumb />
      <div class="login-web">
        <div className="auth-wrapper">
          <div className="auth-content text-center">
            <Card className="borderless">
              <Card.Body className="card-body-logo">
                <div className="login-header">
                  <div className="logo-flex">
                    <div className="logo-item">
                      <img src={clubLogo1} alt="" className="img-fluid img-fluid2 " />
                    </div>
                    <div className="logo-item2">
                      <img src={clientclublogo} alt="" className="img-fluid img-fluid2 " />
                    </div>
                  </div>
                </div>
                <div className="login-body">
                <h5 style={{ textAlign: 'center',fontWeight:"bolder", paddingBottom: '10px' }}>The Belur Club</h5>
                  <FirebaseLogin />
                  <p className="mb-2 text-muted" style={{ textAlign: 'center'  , paddingTop: '10px'}}>
                    Forgot password?{' '}
                    <NavLink to="/auth/reset-password-1" className="f-w-400">
                      Reset
                    </NavLink>
                  </p>
                  {/* 
                  <p className="mb-2 text-muted">
                    If you are Affiliated club member? <br></br>
                    <NavLink to="/auth/affiliated" className="f-w-400">
                      Book Now
                    </NavLink>
                  </p> */}
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="footer-pages">
            <div>
              <a target="_blank" style={{ textDecoration: 'none', color: '#fff', fontWeight: '400' }} href="https://www.belurclub.com/">
                About Us
              </a>
            </div>
            <div onClick={() => handleNavigate('privacy-policy')}>Privacy Policy</div>
            <div onClick={() => handleNavigate('terms-disclaimer-policy')}>Terms and Disclaimer Policy</div>
            <div onClick={() => handleNavigate('refund-cancellation-policy')}>Refund and Cancellation Policy</div>
            <div>
              <a
                target="_blank"
                style={{ textDecoration: 'none', color: '#fff', fontWeight: '400' }}
                href="https://www.belurclub.com/contact"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="login-mobile">
        {/* <div className="auth-wrapper"> */}

        {/* <div className="auth-content text-center"> */}
        <Card className="borderless">
          <Card.Body className="card-body-logo">
            <div className="login-header">
              <div className="logo-flex-1">
                {/* <div className='logo-item'>
                  <img src={clubLogo2} alt="" className="img-fluid img-fluid2 " />
                </div> */}
                <div className="logo-item2">
                  <img src={clientclublogo} alt="" className="img-fluid img-fluid2 " />
                </div>
              
              </div>
            </div>
            <div className="login-body">
              <h5 style={{ textAlign: 'center',fontWeight:"bolder"}}>The Belur Club</h5>
              <h6 style={{ textAlign: 'center', paddingBottom: '10px' }}>LOGIN</h6>
              <FirebaseLogin />
              <p className="mb-2 text-muted" style={{ textAlign: 'center' , paddingTop: '10px' }}>
                Forgot password?{' '}
                <NavLink to="/auth/reset-password-1" className="f-w-400">
                  &nbsp; Reset
                </NavLink>
              </p>
              {/* <p className="mb-2 text-muted" style={{ textAlign: 'center' }}>
                If you are Affliated club member? <br></br>
                <NavLink to="/auth/affiliated" className="f-w-400">
                  Book Now
                </NavLink>
              </p> */}
            </div>

            <div class="footer-page">
              <p className="mb-2 text-muted">
                Powered By <strong style={{ color: '#fd6051' }}>ClubWorld</strong>{' '}
              </p>
            </div>
            <div className="footer-pagess">
              <div>
                <a
                  target="_blank"
                  style={{ textDecoration: 'none', color: '#000', fontWeight: '400' }}
                  href="https://www.belurclub.com/"
                >
                  About Us
                </a>
              </div>
              <div onClick={() => handleNavigate('privacy-policy')}>Privacy Policy</div>
              <div onClick={() => handleNavigate('terms-disclaimer-policy')}>Terms and Disclaimer Policy</div>
              <div onClick={() => handleNavigate('refund-cancellation-policy')}>Refund and Cancellation Policy</div>
              <div>
                <a
                  target="_blank"
                  style={{ textDecoration: 'none', color: '#000', fontWeight: '400' }}
                  href="https://www.belurclub.com/contact"
                >
                  Contact Us
                </a>
              </div>

              
            </div>
            
          </Card.Body>
          
        </Card>
      </div>
      {/* </div> */}
      {/* </div></div> */}
    </React.Fragment>
  );
};

export default Signin1;

